import { render, staticRenderFns } from "./UpdatePreferences.vue?vue&type=template&id=bedcb5d6&scoped=true"
import script from "./UpdatePreferences.vue?vue&type=script&lang=js"
export * from "./UpdatePreferences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedcb5d6",
  null
  
)

export default component.exports